import { IToken } from "@beefree.io/sdk/dist/types/bee";

import { getBeeToken } from "generated/api/bee-token";

export type BeeTokenType = "email" | "lp";

const beeTokenApi = getBeeToken();

/**
 * Fetches a BEE editor token for the given client and content type. Logs and
 * rethrows on failure so callers can abort BEE initialization.
 */
export async function fetchBeeToken(clientId: string, type: BeeTokenType): Promise<IToken> {
  try {
    const token = await beeTokenApi.getToken({ clientId, type });
    return token as unknown as IToken;
  } catch (error) {
    console.error(`Failed to fetch ${type} BEE token:`, error);
    throw error;
  }
}
